var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPersonIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1880_6736",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1880_6736)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.1576,
    cy: 4.98548,
    r: 2.98548,
    fill: "#ED705B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3135 13.5806C13.3135 12.9034 13.1801 12.2328 12.9209 11.6072C12.6618 10.9815 12.2819 10.413 11.8031 9.9342C11.3242 9.45535 10.7558 9.07551 10.1301 8.81636C9.50449 8.55721 8.83393 8.42383 8.15673 8.42383C7.47954 8.42383 6.80898 8.55721 6.18334 8.81636C5.55769 9.07551 4.98922 9.45535 4.51037 9.9342C4.03153 10.413 3.65168 10.9815 3.39253 11.6072C3.13338 12.2328 3 12.9034 3 13.5806L8.15673 13.5806H13.3135Z",
    fill: "#ED705B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonIcon);
export default __webpack_public_path__ + "static/media/Person-icon.ed3e9f6960a9ed5fb57a4eafb0559051.svg";
export { ForwardRef as ReactComponent };